import React from 'react';
import { healthCalculators } from './ConstantsHealthCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'Kalkulator Gratis untuk Menghitung Semua Hal Terkait Kesehatan Manusia dan Kebugaran Fisik - Temukan Sekarang';
const DESCRIPTION = 'Jelajahi koleksi kalkulator kesehatan dan kebugaran pilihan kami, seperti Kalkulator Indeks Massa Tubuh BMI, Kalkulator Kalori Harian, Tingkat Metabolisme Basal BMR, dan banyak lagi.';
const KEYWORDS = 'Kalkulator BMI, Kalkulator Kalori, BMR, Berat Badan Ideal, Persentase Lemak, Karbohidrat, Satuan Energi Makanan';
const OG_URL = 'https://do-calculate.com/id/health-calculators';
function CalculatorsList() {
    return (
        <div className="container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                <u><p>Jika Anda mengetahui atau ingin menambahkan kalkulator kesehatan lainnya, silakan hubungi kami melalui email di <b>info@do-calculate.com</b> Kami akan dengan senang hati menambahkannya! :)</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Kalkulator</th>
                        <th >Deskripsi</th>
                     </tr>
                </thead>
                <tbody>
                    {healthCalculators.map((calculator, index) => (
                        <tr key={index}>
                             <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                             </td>
                             <td><p>{calculator.description}</p></td>
                         </tr>
                    ))}
                </tbody>
             </table>
            <br />
        </div>
    );
}
export default CalculatorsList;